module.exports = __webpack_public_path__ + "static/img/solutionDetailIcon04.f829682.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailIcon04.png
// module id = efBh
// module chunks = 0